module.exports = __webpack_public_path__ + "static/logo-eos-c9070a08f554bb6b71cff0af4a917f6d.png";